module.exports = __webpack_public_path__ + "img/MissionVisionCore.323f1b01.png";